export const LESSON = 'lesson';
export const HOMEWORK = 'homework';
export const TETHERING = 'tethering';
export const PARENTWEB = 'parentweb';
export const SOLO = 'solo';

// Temporary - for redirecting to the english app.
export const ENGLISH = 'english';

// Temporary - for redirecting to the quiz app.
export const QUIZ = 'quiz';

// Temporary - for redirecting to the science app.
export const SCIENCE = 'science';
